module.exports = __webpack_public_path__ + "img/red.b696766a.svg";